// ##### 24-06-12 Komarov
import React from 'react';
// ##### 25-05-02 Komarov
import { useSelector } from 'react-redux';

// ##### Komarov 2025-07-13
const HeaderH2 = ({ className, fontSize }) => {
  // ##### Komarov 2025-08-05
  const ArkturFrontPageSloganMessage = useSelector(state => state.pagesRedux[state.language]?.ArkturFrontPageSloganMessage || '');
  return (
    <h2
      // ##### Komarov 2025-07-23
      data-component="HeaderSsrH2"
      className={className}
      // ##### 23-09-23 Komarov
      style={{
        margin: 'auto',
        color: 'rgb(122,6,8)',
        fontSize: fontSize,
        fontFamily: 'Arial',
        fontWeight: 'bold',
      }}
    >
      {
        // ##### 23-10-04 Komarov
        ArkturFrontPageSloganMessage
      }{' '}
    </h2>
  );
};

export default HeaderH2;
